export const MAX_NOTE_ATTACHMENT_BYTES = 10 * 1024 * 1024;

export const MAX_NOTE_ATTACHMENT_COUNT = 5;

export const NOTE_ATTACHMENTS_FIELD = "attachments";

export const NOTE_ATTACHMENT_REMOVAL_LIST_FIELD = "removeAttachmentBlobNames";

export const DEFAULT_NOTE_EXPIRY = "never";

export const NOTE_DOMAIN = "netpad.click";

export const SUPPORTED_NOTE_ATTACHMENT_EXTENSIONS = Object.freeze([
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".webp",
  ".bmp",
  ".tif",
  ".tiff",
  ".pdf",
  ".doc",
  ".docx",
  ".pptx",
  ".xls",
  ".xlsx",
  ".csv",
  ".txt",
  ".md",
  ".rtf",
  ".json",
  ".xml",
  ".yaml",
  ".yml",
  ".js",
  ".jsx",
  ".ts",
  ".tsx",
  ".py",
  ".go",
  ".java",
  ".c",
  ".cpp",
  ".h",
  ".hpp",
  ".cs",
  ".php",
  ".rb",
  ".rs",
  ".swift",
  ".kt",
  ".kts",
  ".scala",
  ".sh",
  ".bash",
  ".zsh",
  ".sql",
  ".html",
  ".css",
  ".scss",
  ".sass",
  ".less",
]);

export const BLOCKED_NOTE_ATTACHMENT_EXTENSIONS = Object.freeze([
  ".exe",
  ".zip",
  ".dmg",
]);

export const NOTE_ATTACHMENT_ACCEPT =
  SUPPORTED_NOTE_ATTACHMENT_EXTENSIONS.join(",");
